import React, { useState } from 'react';
import { APP_TERMS } from '../../../app-terms';
import { Col, Form, Row, Upload } from 'antd';
import PropTypes from 'prop-types';
import apiService from '../../../axios/apiService';
import { CASE_FORM_TYPES } from '../../../appContants';

const UploadListItem = ({ originNode }) => {

  return (
    <div style={{ cursor: 'pointer' }}>
      {originNode}
    </div>
  );
};
UploadListItem.propTypes = {
  originNode: PropTypes.any,
  file: PropTypes.any,
};
const UploadFiles = ({ form, defaultFileList, onUploading }) => {
  const [fileList, setFileList] = useState([]);

  const handleUpload = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      onUploading(true);
      let uploadComplete = false;
      const safeOnProgress = (event) => {
        if (!uploadComplete) onProgress(event);
      };
      // Fetch the presigned URL from the server
      const signedUrl = await apiService.getPresignedUrl({
        fileName: file?.name,
        fileSize: file?.size,
        fileContentType: file?.type || 'application/dicom', // By default save as DICOM
      });
      if (signedUrl) {
        // Upload file using the signed URL
        const formData = new FormData();
        const fields = signedUrl?.preSigned?.fields;
        for (const key in fields) {
          if (fields.hasOwnProperty.call(fields, key)) {
            const value = fields[key];
            formData.append(key, value);
          }
        }
        formData.append('file', file);
        const response = await apiService.uploadWithPresignedUrl(
          signedUrl?.preSigned?.url,
          formData,
          safeOnProgress
        );
        uploadComplete = true;
        onSuccess({ result: response.data, file: { ...file, uid: signedUrl?.objectKey } });
      }
    } catch (error) {
      onError(error);
      console.log('error on upload ', error);
    } finally {
      onUploading(false);
    }
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  return (
    <>
      <Form
        name={CASE_FORM_TYPES.uploadFiles}
        form={form}
        layout="vertical"
        autoComplete="off"
      >
        <Row gutter={16} className="mt-3">
          <Col>
            <h4>{`${APP_TERMS.generic_upload} ${APP_TERMS.generic_documents}`}</h4>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="files"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              required
              rules={[
                {
                  message: APP_TERMS.file_upload_invalid_validation,
                  validator: (_, value) => {
                    return value?.length
                      ? Promise.resolve()
                      : Promise.reject(
                        new Error(APP_TERMS.file_upload_invalid_validation)
                      );
                  },
                },
              ]}
            >
              <Upload.Dragger
                name="files"
                onRemove={(file) => {
                  const index = fileList.indexOf(file);
                  const newFileList = fileList.slice();
                  newFileList.splice(index, 1);
                  setFileList(newFileList);
                }}
                fileList={fileList}
                defaultFileList={defaultFileList}
                customRequest={handleUpload}
                itemRender={(originNode, file) => (
                  <UploadListItem originNode={originNode} file={file} />
                )}
              >
                <p className="ant-upload-drag-icon px-3 pt-3">
                  <i className="fa fa-3x fa-arrow-up-from-bracket"></i>
                </p>
                <p className="ant-upload-text px-3">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint px-3 pb-3">
                  Support for a single or bulk upload.
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

UploadFiles.propTypes = {
  form: PropTypes.any,
  defaultFileList: PropTypes.array,
  onUploading: PropTypes.func,
};

export default UploadFiles;
